import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showSnackbar } from '../api/snackbarSlice';
import { apiClient } from '../api/axios';

const fetchProfiles = async (query) => {
  const { data } = await apiClient.get('/business-profiles/summary', { params: query.queryKey[1] });
  return data;
};

export const useGetBusinessProfilesHandler = ({ searchQuery, enabled = true }) => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['businessProfiles', { ...searchQuery }],
    queryFn: fetchProfiles,
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  if (isError) {
    if (error instanceof AxiosError) {
      dispatch(
        showSnackbar({
          message: error.response?.data?.message || error.message,
          severity: 'error',
        }),
      );
    } else {
      dispatch(
        showSnackbar({
          message: 'Failed to fetch business profiles',
          severity: 'error',
        }),
      );
    }
  }

  return {
    profiles: data?.content ?? [],
    totalProfiles: data?.total_elements ?? 0,
    isLoading,
    refetch,
  };
};
